import { editDeviation } from '../../redux/deviations/actionCreators';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { useCallback } from 'react';
export function useEditDeviationAction(deviation) {
    const dispatchEditDeviation = useAction(editDeviation);
    return useCallback(()=>{
        dispatchEditDeviation({
            deviation
        });
    }, [
        deviation,
        dispatchEditDeviation
    ]);
}

//# sourceMappingURL=useEditDeviationAction.js.map